export const ADD_LOOKUP = "ADD_LOOKUP";
export const ADD_CURRENT_ROUTE = "ADD_CURRENT_ROUTE";
export const EDIT_LOOKUP = "EDIT_LOOKUP";
export const FETCH_LOOKUP = "FETCH_LOOKUP";
export const DELETE_LOOKUP = "DELETE_LOOKUP";
export const DESTROY_LOOKUP = "DESTROY_LOOKUP";
export const FETCH_LOOKUP_META = "FETCH_LOOKUP_META";
export const FETCHING_LOOKUP_META = "FETCHING_LOOKUP_META";
export const EDIT_LOOKUP_META = "EDIT_LOOKUP_META";
export const ADD_PROFILE = 'ADD_PROFILE';
export const ADD_EXCEPTION_MESSAGE = 'ADD_EXCEPTION_MESSAGE';
export const ADD_NEWS = 'ADD_NEWS';
export const DELETE_NEWS = 'DELETE_NEWS';
export const EDIT_NEWS = 'EDIT_NEWS';
export const DESTROY_NEWS = 'DESTROY_NEWS';
export const FETCH_NEWS = 'FETCH_NEWS';
export const FETCHING_NEWS = 'FETCHING_NEWS';
export const FETCH_NEWS_META = 'FETCH_NEWS_META';
export const FETCHING_NEWS_META = 'FETCHING_NEWS_META';
export const EDIT_NEWS_META = 'EDIT_NEWS_META';
export const ADD_COUPON = 'ADD_COUPON';
export const DELETE_COUPON = 'DELETE_COUPON';
export const EDIT_COUPON = 'EDIT_COUPON';
export const FETCH_COUPON = 'FETCH_COUPON';
export const DESTROY_COUPON = 'DESTROY_COUPON';
export const FETCHING_COUPON = 'FETCHING_COUPON';
export const FETCH_COUPON_META = 'FETCH_COUPON_META';
export const FETCHING_COUPON_META = 'FETCHING_COUPON_META';
export const EDIT_COUPON_META = 'EDIT_COUPON_META';
export const ADD_REDEEM = 'ADD_REDEEM';
export const DELETE_REDEEM = 'DELETE_REDEEM';
export const EDIT_REDEEM = 'EDIT_REDEEM';
export const FETCH_REDEEM = 'FETCH_REDEEM';
export const DESTROY_REDEEM = 'DESTROY_REDEEM';
export const FETCHING_REDEEM = 'FETCHING_REDEEM';
export const FETCH_REDEEM_META = 'FETCH_REDEEM_META';
export const FETCHING_REDEEM_META = 'FETCHING_REDEEM_META';
export const EDIT_REDEEM_META = 'EDIT_REDEEM_META';
export const ADD_PAGES = 'ADD_PAGES';
export const DELETE_PAGES = 'DELETE_PAGES';
export const EDIT_PAGES = 'EDIT_PAGES';
export const FETCH_PAGES = 'FETCH_PAGES';
export const FETCHING_PAGES = 'FETCHING_PAGES';
export const FETCH_PAGES_META = 'FETCH_PAGES_META';
export const FETCHING_PAGES_META = 'FETCHING_PAGES_META';
export const EDIT_PAGES_META = 'EDIT_PAGES_META';

export const ADD_CMS_PAGES = 'ADD_CMS_PAGES';
export const DELETE_CMS_PAGES = 'DELETE_CMS_PAGES';
export const EDIT_CMS_PAGES = 'EDIT_CMS_PAGES';
export const FETCH_CMS_PAGES = 'FETCH_CMS_PAGES';
export const FETCHING_CMS_PAGES = 'FETCHING_CMS_PAGES';
export const FETCH_CMS_PAGES_META = 'FETCH_CMS_PAGES_META';
export const FETCHING_CMS_PAGES_META = 'FETCHING_CMS_PAGES_META';
export const EDIT_CMS_PAGES_META = 'EDIT_CMS_PAGES_META';

export const ADD_FAQS = 'ADD_FAQS';
export const DELETE_FAQS = 'DELETE_FAQS';
export const EDIT_FAQS = 'EDIT_FAQS';
export const FETCH_FAQS = 'FETCH_FAQS';
export const DESTROY_FAQS = 'DESTROY_FAQS';
export const FETCHING_FAQS = 'FETCHING_FAQS';
export const FETCH_FAQS_META = 'FETCH_FAQS_META';
export const FETCHING_FAQS_META = 'FETCHING_FAQS_META';
export const EDIT_FAQS_META = 'EDIT_FAQS_META';

export const ADD_FAQ_TYPES = 'ADD_FAQ_TYPES';
export const DELETE_FAQ_TYPES = 'DELETE_FAQ_TYPES';
export const EDIT_FAQ_TYPES = 'EDIT_FAQ_TYPES';
export const FETCH_FAQ_TYPES = 'FETCH_FAQ_TYPES';
export const DESTROY_FAQ_TYPES = 'DESTROY_FAQ_TYPES';
export const FETCHING_FAQ_TYPES = 'FETCHING_FAQ_TYPES';
export const FETCH_FAQ_TYPES_META = 'FETCH_FAQ_TYPES_META';
export const FETCHING_FAQ_TYPES_META = 'FETCHING_FAQ_TYPES_META';
export const EDIT_FAQ_TYPES_META = 'EDIT_FAQ_TYPES_META';

export const FETCH_FEEDBACK = 'FETCH_FEEDBACK';
export const EDIT_FEEDBACK = 'EDIT_FEEDBACK';
export const DESTROY_FEEDBACK = 'DESTROY_FEEDBACK';
export const FETCHING_FEEDBACK = 'FETCHING_FEEDBACK';
export const FETCH_FEEDBACK_META = 'FETCH_FEEDBACK_META';
export const FETCHING_FEEDBACK_META = 'FETCHING_FEEDBACK_META';
export const ADD_INVENTORY_CATEGORIES = 'ADD_INVENTORY_CATEGORIES';
export const FETCH_INVENTORY_CATEGORIES = 'FETCH_INVENTORY_CATEGORIES';
export const EDIT_INVENTORY_CATEGORIES = 'EDIT_INVENTORY_CATEGORIES';
export const DELETE_INVENTORY_CATEGORIES = 'DELETE_INVENTORY_CATEGORIES';
export const FETCHING_INVENTORY_CATEGORIES_META = 'FETCHING_INVENTORY_CATEGORIES_META';
export const FETCH_INVENTORY_CATEGORIES_META = 'FETCH_INVENTORY_CATEGORIES_META';
export const FETCH_ITEM_COPIES = 'FETCH_ITEM_COPIES';
export const EDIT_ITEM_COPY = 'EDIT_ITEM_COPY';
export const DESTROY_ITEM_COPY = 'DESTROY_ITEM_COPY';
export const EDIT_ITEM_COPIES_META = 'EDIT_ITEM_COPIES_META';
export const FETCH_ITEM_COPIES_META = "FETCH_ITEM_COPIES_META";
export const FETCHING_ITEM_COPIES_META = "FETCHING_ITEM_COPIES_META";
export const FETCH_ITEM = 'FETCH_ITEM';
export const FETCHING_ITEM_META = 'FETCHING_ITEM_META';
export const FETCH_TV_KEY = 'FETCH_TV_KEY';
export const FETCH_TV_KEY_META = 'FETCH_TV_KEY_META';
export const ADD_TV_KEY = 'ADD_TV_KEY';
export const EDIT_TV_KEY = 'EDIT_TV_KEY';
export const DELETE_TV_KEY = 'DELETE_TV_KEY';
export const ADD_ITEM = 'ADD_ITEM';
export const EDIT_ITEM = 'EDIT_ITEM';
export const DESTROY_ITEM = 'DESTROY_ITEM';
export const EDIT_ITEM_META = 'EDIT_ITEM_META';
export const FETCH_ITEM_META = "FETCH_ITEM_META";
export const ADD_AUCTION = 'ADD_AUCTION';
export const DELETE_AUCTION = 'DELETE_AUCTION';
export const FETCH_AUCTION = 'FETCH_AUCTION';
export const DESTROY_AUCTION = 'DESTROY_AUCTION';
export const FETCH_AUCTION_META = "FETCH_AUCTION_META";
export const FETCH_TRANSACTION = 'FETCH_TRANSACTION';
export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const EDIT_TRANSACTION = 'EDIT_TRANSACTION';
export const DESTROY_TRANSACTION = 'DESTROY_TRANSACTION';
export const EDIT_TRANSACTION_META = 'EDIT_TRANSACTION_META';
export const FETCH_TRANSACTION_META = "FETCH_TRANSACTION_META";
export const FETCHING_TRANSACTION_META = "FETCHING_TRANSACTION_META";
export const USER_IS_ENABLED = "USER_IS_ENABLED";
export const USER_IS_CONFIRMED = "USER_IS_CONFIRMED";
export const USER_IS_DELETED = "USER_IS_DELETED";
export const FETCH_USER = "FETCH_USER";
export const DESTROY_USER = "DESTROY_USER";
export const FETCH_USER_META = "FETCH_USER_META";
export const FETCHING_USER_META = "FETCHING_USER_META";
export const FETCH_ADMIN_USER = "FETCH_ADMIN_USER";
export const FETCH_ADMIN_USER_META = "FETCH_ADMIN_USER_META";
export const FETCHING_ADMIN_USER_META = "FETCHING_ADMIN_USER_META";
export const EDIT_USER_META = "EDIT_USER_META";
export const DESTROY_ADMIN_USER = "DESTROY_ADMIN_USER";
export const ADD_INVENTORY = "ADD_INVENTORY";
export const FETCH_INVENTORY = "FETCH_INVENTORY";
export const EDIT_INVENTORY = "EDIT_INVENTORY";
export const DELETE_INVENTORY = "DELETE_INVENTORY";
export const FETCHING_INVENTORY_META = "FETCHING_INVENTORY_META";
export const FETCH_INVENTORY_META = "FETCH_INVENTORY_META";
export const EDIT_INVENTORY_META = "EDIT_INVENTORY_META";
export const FETCH_COLLECTION = "FETCH_COLLECTION";
export const ADD_COLLECTION = "ADD_COLLECTION";
export const EDIT_COLLECTION = "EDIT_COLLECTION";
export const REMOVE_COLLECTION = "REMOVE_COLLECTION";
export const FETCH_COLLECTION_META = 'FETCH_COLLECTION_META';
export const FETCHING_COLLECTION_META = 'FETCHING_COLLECTION_META';
export const FETCH_REWARDS = 'FETCH_REWARDS';
export const ADD_REWARDS = 'ADD_REWARDS';
export const EDIT_REWARDS = 'EDIT_REWARDS';
export const REMOVE_REWARDS = 'REMOVE_REWARDS';
export const FETCH_REWARDS_META = 'FETCH_REWARDS_META';
export const EDIT_REWARDS_META = 'EDIT_REWARDS_META';
export const FETCHING_REWARDS_META = 'FETCHING_REWARDS_META';
export const FETCH_BADGES = 'FETCH_BADGES';
export const ADD_BADGES = 'ADD_BADGES';
export const EDIT_BADGES = 'EDIT_BADGES';
export const REMOVE_BADGES = 'REMOVE_BADGES';
export const FETCH_BADGES_META = 'FETCH_BADGES_META';
export const EDIT_BADGES_META = 'EDIT_BADGES_META';
export const FETCHING_BADGES_META = 'FETCHING_BADGES_META';
export const ADD_COUNTRY = 'ADD_COUNTRY';
export const EDIT_COUNTRY = 'EDIT_COUNTRY';
export const REMOVE_COUNTRY = 'REMOVE_COUNTRY';
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const FETCH_COUNTRIES_META = 'FETCH_COUNTRIES_META';
export const EDIT_COUNTRIES_META = 'EDIT_COUNTRIES_META';
export const FETCHING_COUNTRIES_META = 'FETCHING_COUNTRIES_META';

// ISL Teams
export const FETCH_TEAMS = 'FETCH_TEAMS';
export const ADD_TEAM = 'ADD_TEAM';
export const EDIT_TEAM = 'EDIT_TEAM';
export const DESTROY_TEAM = 'DESTROY_TEAM';
export const DELETE_TEAM = 'DELETE_TEAM';
export const EDIT_TEAMS_META = 'EDIT_TEAMS_META';
export const FETCH_TEAMS_META = 'FETCH_TEAMS_META';
export const FETCHING_TEAMS_META = 'FETCHING_TEAMS_META'

// ISL Teams Trading Cards
export const FETCH_TRADING_CARDS = 'FETCH_TRADING_CARDS';
export const ADD_TRADING_CARD = 'ADD_TRADING_CARD';
export const EDIT_TRADING_CARD = 'EDIT_TRADING_CARD';
export const DELETE_TRADING_CARD = 'DELETE_TRADING_CARD';
export const DESTROY_TRADING_CARD = 'DESTROY_TRADING_CARD';
export const EDIT_TRADING_CARDS_META = 'EDIT_TRADING_CARDS_META';
export const FETCH_TRADING_CARDS_META = 'FETCH_TRADING_CARDS_META';
export const FETCHING_TRADING_CARDS_META = 'FETCHING_TRADING_CARDS_META'

// ISL Rewards/Free NFT
export const FETCH_ISL_REWARDS = 'FETCH_ISL_REWARDS';
export const FETCH_ISL_REWARDS_META = 'FETCH_ISL_REWARDS_META';
export const FETCHING_ISL_REWARDS_META = 'FETCHING_ISL_REWARDS_META'